const regex = new RegExp(/(^https?:\/\/)((www.)?scmp.com|.*.product-web.dev-2.scmp.tech)/);
export const checkIsInternalScmpLink = (href: string) => regex.test(href);

export const checkIsDrupalAutoLink = (className?: string) =>
  className?.includes("d8-auto-link") ?? false;

type CheckIsDigitalArchiveLinkParameters = {
  className?: string;
  isInternalScmpLink: boolean;
  parentSchemaNode?: SchemaNode;
};

export const checkIsDigitalArchiveLink = ({
  className,
  isInternalScmpLink,
  parentSchemaNode,
}: CheckIsDigitalArchiveLinkParameters) =>
  !checkIsDrupalAutoLink(className) &&
  ["h3", "p"].includes(parentSchemaNode?.type ?? "") &&
  parentSchemaNode?.children?.length === 1 &&
  parentSchemaNode.children[0]?.type === "a" &&
  isInternalScmpLink;
